// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from '@/modules/common/components/Select';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import DatePickerField from '@/modules/common/components/DatePickerField';
import { withFetch } from '~/hocs/fetch';
import { formatDate } from '~/common';

const initialValues = {
    offer: '',
    type: '',
    status: '',
    price: '',
    date_from: new Date(),
};

const initialErrors = {
    offer: '',
    type: '',
    status: '',
    price: '',
    date_from: '',
};

let abortController;

const DialogAdd = (props) => {
    const { username } = useParams();

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    const getOfferOptions = () => {
        return props.offers.map((offer) => ({title: offer.offer_name, value: offer.id.toString()}));
    };

    const getTypeOptions = () => {
        let options = [];
        const id = parseInt(values.offer);
        if (!isNaN(id)) {
            const types = props.types.filter((type) => type.offer.id === id);
            options = types.map((type) => ({title: type.name, value: type.id.toString()}));
        }
        return options;
    };

    const getStatusOptions = () => {
        let options = [];
        const id = parseInt(values.offer);
        if (!isNaN(id)) {
            const statuses = props.statuses.filter((status) => status.offer.id === id);
            options = statuses.map((status) => ({title: status.status, value: status.id.toString()}));
        }
        return options;
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.post(
            `/api/prices/`, {
                username: username,
                offer: values.offer,
                type: values.type,
                status: values.status,
                date_from: (values.date_from) ? formatDate(values.date_from) : null,
                price: values.price,
            },
            abortController,
        ).then(({ok, data}) => {
            if (ok) {
                if (props.autoClose) {
                    clear();
                }
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.offer = (data.offer) ? data.offer[0] : '';
                _errors.type = (data.type) ? data.type[0] : '';
                _errors.status = (data.status) ? data.status[0] : '';
                _errors.price = (data.price) ? data.price[0] : '';
                _errors.date_from = (data.date_from) ? data.date_from[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm title="Добавление цены" label="Добавить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
                    autoClose={{
                        checked: props.autoClose,
                        onChange: (event) => {props.setAutoClose(event.target.checked);}
                    }}
        >
            <Select label="Оффер" options={getOfferOptions()}
                    value={values.offer}
                    onChange={(event) => setValues({...values, offer: event.target.value, type: '', status: ''})}
                    error={errors.offer.length > 0}
                    helperText={errors.offer}
                    onFocus={handleFocus('offer')}
            />
            <Select label="Тип заявки" options={getTypeOptions()}
                    value={values.type} onChange={handleChange('type')}
                    error={errors.type.length > 0}
                    helperText={errors.type}
                    onFocus={handleFocus('type')}
            />
            <Select label="Статус" options={getStatusOptions()}
                    value={values.status} onChange={handleChange('status')}
                    error={errors.status.length > 0}
                    helperText={errors.status}
                    onFocus={handleFocus('status')}
            />
            <TextField label="Цена" type="number" inputProps={{min: 0}}
                       value={values.price} onChange={handleChange('price')}
                       error={errors.price.length > 0}
                       helperText={errors.price}
                       onFocus={handleFocus('price')}
            />
            <DatePickerField label="Начальная дата"
                             value={values.date_from}
                             setValue={(value) => setValues({...values, date_from: value})}
                             error={errors.date_from.length > 0}
                             helperText={errors.date_from}
                             onFocus={handleFocus('date_from')}
            />
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    autoClose: PropTypes.bool.isRequired,
    setAutoClose: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withFetch(Component);

export default connect(
    (state) => ({
        types: state.types,
        offers: state.cfg.offers,
        statuses: state.statuses,
    })
)(Component);
